import { REST_API } from '../../constants/restApiUrls';
import HttpConnection from '../../utils/http-connection';

/**
 * 選択肢情報を取得する
 *
 */
export async function getSelects() {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.SETTING.MAIL_MAGAZINE_ENTRY.SELECT, {})
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * 会員を取得する
 *
 */
export async function getMembers(request) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.SETTING.MAIL_MAGAZINE_ENTRY.MEMBERS, request)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * テンプレートを取得する
 *
 */
export async function getTemplates(storeId) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.SETTING.MAIL_MAGAZINE_ENTRY.TEMPLATES, storeId)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
